module.exports = "\n\n\n<h3 *ngIf=\"message\">{{message}}</h3>\n\n<div *ngIf=\"html\" [innerHTML]=\"html | trustHtml\"></div>\n\n<div mat-dialog-actions>\n  <button mat-button [mat-dialog-close]=\"true\" tabindex=\"2\">Yes</button>\n  <button mat-button [mat-dialog-close]=\"false\" tabindex=\"-1\">No</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/components/yes-no-dialog/yes-no-dialog.html
// module id = ../../../../../src/app/admin-area/components/yes-no-dialog/yes-no-dialog.html
// module chunks = main